// auth
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_AUTH_USER = 'GET_AUTH_USER';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';
export const CHANGE_PIN_CODE = "CHANGE_PIN_CODE";
export const RESET_PIN_CODE = "RESET_PIN_CODE";

// User Actions
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_SPECIFIC_USER = "GET_SPECIFIC_USER";
export const CREATE_NEW_USER = "CREATE_NEW_USER";
export const UPDATE_SPECIFIC_USER = "UPDATE_SPECIFIC_USER";
export const REMOVE_USERS = "REMOVE_USERS";
export const UPDATE_LAST_SEEN_USER = "UPDATE_LAST_SEEN_USER";

// permission
export const GET_ALL_PERMISSIONS = "GET_ALL_PERMISSIONS";
export const UPDATE_ROLE_PERMISSIONS = "UPDATE_ROLE_PERMISSIONS";
export const GET_PERMISSIONS_BY_ROLE = "GET_PERMISSIONS_BY_ROLE";
export const GET_PERMISSIONS_BY_USER = "GET_PERMISSIONS_BY_USER";

// role
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const CREATE_NEW_ROLE = "CREATE_NEW_ROLE";
export const UPDATE_SPECIFIC_ROLE = "UPDATE_SPECIFIC_ROLE";
export const REMOVE_ROLES = "REMOVE_ROLES";
export const GET_SPECIFIC_ROLE = "GET_SPECIFIC_ROLE";

// config
export const GET_CONFIG = "GET_CONFIG";
export const SET_CONFIG = "SET_CONFIG";
export const FETCH_SERVICE_VISIBILITY_CONFIG = "FETCH_SERVICE_VISIBILITY_CONFIG";
export const UPDATE_SERVICE_VISIBILITY_CONFIG = "UPDATE_SERVICE_VISIBILITY_CONFIG";

// Service
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const FETCH_SERVICE_DETAIL = 'FETCH_SERVICE_DETAIL';
export const CREATE_SERVICE = 'CREATE_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const DELETE_SERVICES = 'DELETE_SERVICES';
export const FETCH_ACTIVE_SERVICES = 'FETCH_ACTIVE_SERVICES';

// Danh sách khách hàng
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_ACTIVE_CUSTOMERS = 'FETCH_ACTIVE_CUSTOMERS';
export const FETCH_ORTHODONTIC_CUSTOMERS = 'FETCH_ORTHODONTIC_CUSTOMERS';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCH_CUSTOMER_BY_FB_NAME = 'FETCH_CUSTOMER_BY_FB_NAME';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const CREATE_CUSTOMER_FROM_PROSPECT = 'CREATE_CUSTOMER_FROM_PROSPECT';
export const CREATE_CUSTOMER_FROM_CHAT = 'CREATE_CUSTOMER_FROM_CHAT';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const UPDATE_CUSTOMER_FROM_CHAT = 'UPDATE_CUSTOMER_FROM_CHAT';
export const DELETE_CUSTOMERS = 'DELETE_CUSTOMERS';
export const EXPORT_CUSTOMERS_EXCEL = 'EXPORT_CUSTOMERS_EXCEL';
export const SET_CUSTOMER_PRIMARY_PHONE = 'SET_CUSTOMER_PRIMARY_PHONE';
export const FETCH_NEXT_MEDICAL_BOOK_NUMBER = 'FETCH_NEXT_MEDICAL_BOOK_NUMBER';
export const FETCH_CUSTOMER_PHONES = 'FETCH_CUSTOMER_PHONES';


// Customer payment
export const GET_CUSTOMER_PAYMENT_CUSTOMER = "GET_CUSTOMER_PAYMENT_CUSTOMER";
export const REMOVE_CUSTOMER_PAYMENT = "REMOVE_CUSTOMER_PAYMENT";
export const CREATE_CUSTOMER_PAYMENT = "CREATE_CUSTOMER_PAYMENT";
export const UPDATE_SPECIFIC_CUSTOMER_PAYMENT = "UPDATE_SPECIFIC_CUSTOMER_PAYMENT";
export const GET_SPECIFIC_CUSTOMER_PAYMENT = "GET_SPECIFIC_CUSTOMER_PAYMENT";

// Nhóm khách hàng
export const GET_LIST_CUSTOMER_GROUP = "GET_LIST_CUSTOMER_GROUP";
export const GET_SPECIFIC_CUSTOMER_GROUP = "GET_SPECIFIC_CUSTOMER_GROUP";
export const UPDATE_SPECIFIC_CUSTOMER_GROUP = "UPDATE_SPECIFIC_CUSTOMER_GROUP";
export const CREATE_NEW_CUSTOMER_GROUP = "CREATE_NEW_CUSTOMER_GROUP";
export const REMOVE_CUSTOMER_GROUP = "REMOVE_CUSTOMER_GROUP";
export const GET_CUSTOMER_GROUP_ACTIVE = "GET_CUSTOMER_GROUP_ACTIVE";

// Form dữ liệu khách hàng
export const UPDATE_SPECIFIC_CUSTOMER_DATA = "UPDATE_SPECIFIC_CUSTOMER_DATA";
export const CREATE_NEW_CUSTOMER_DATA = "CREATE_NEW_CUSTOMER_DATA";

// Tra cứu khách hàng
export const LOOKUP_CUSTOMERS = "LOOKUP_CUSTOMERS";

// Tra cứu khách hàng phụ tá
export const LIST_CUSTOMER_DOCTOR_ASSISTANT = "LIST_CUSTOMER_DOCTOR_ASSISTANT";


// Lich hen
export const GET_LIST_APPOINTMENTS = "GET_LIST_APPOINTMENTS";
export const GET_SPECIFIC_APPOINTMENT = "GET_SPECIFIC_APPOINTMENT";
export const UPDATE_SPECIFIC_APPOINTMENT = "UPDATE_SPECIFIC_APPOINTMENT";
export const CREATE_NEW_APPOINTMENT = "CREATE_NEW_APPOINTMENT";
export const REMOVE_APPOINTMENT = "REMOVE_APPOINTMENT";
export const UPDATE_SPECIFIC_APPOINTMENT_STATUS = "UPDATE_SPECIFIC_APPOINTMENT_STATUS";
export const TRANSFER_APPOINTMENT_TO_STAFF = "TRANSFER_APPOINTMENT_TO_STAFF";
export const GET_APPOINTMENT_LIST_BY_CUSTOMER = "GET_APPOINTMENT_LIST_BY_CUSTOMER";
export const CHANGE_APPOINTMENT = "CHANGE_APPOINTMENT";
export const APPOINTMENT_EXPORT_EXCEL = "APPOINTMENT_EXPORT_EXCEL";
export const GET_APPOINTMENTS_STATISTICS = "GET_APPOINTMENTS_STATISTICS";

// Hạng khách hàng
export const GET_LIST_CUSTOMER_CLASS = "GET_LIST_CUSTOMER_CLASS";
export const GET_SPECIFIC_CUSTOMER_CLASS = "GET_SPECIFIC_CUSTOMER_CLASS";
export const UPDATE_SPECIFIC_CUSTOMER_CLASS = "UPDATE_SPECIFIC_CUSTOMER_CLASS";
export const CREATE_NEW_CUSTOMER_CLASS = "CREATE_NEW_CUSTOMER_CLASS";
export const REMOVE_CUSTOMER_CLASS = "REMOVE_CUSTOMER_CLASS";
export const GET_CUSTOMER_CLASS_ACTIVE = "GET_CUSTOMER_CLASS_ACTIVE";

// Quan hệ gia đình
export const GET_LIST_RELATIONSHIP_TYPES = "GET_LIST_RELATIONSHIP_TYPES";
export const GET_SPECIFIC_RELATIONSHIP_TYPES = "GET_SPECIFIC_RELATIONSHIP_TYPES";
export const UPDATE_SPECIFIC_RELATIONSHIP_TYPES = "UPDATE_SPECIFIC_RELATIONSHIP_TYPES";
export const CREATE_NEW_RELATIONSHIP_TYPES = "CREATE_NEW_RELATIONSHIP_TYPES";
export const REMOVE_RELATIONSHIP_TYPES = "REMOVE_RELATIONSHIP_TYPES";
export const GET_RELATIONSHIP_TYPES_ACTIVE = "GET_RELATIONSHIP_TYPES_ACTIVE";

// Trạng thái khách hàng
export const GET_LIST_CUSTOMER_STATUS = "GET_LIST_CUSTOMER_STATUS";
export const GET_SPECIFIC_CUSTOMER_STATUS = "GET_SPECIFIC_CUSTOMER_STATUS";
export const UPDATE_SPECIFIC_CUSTOMER_STATUS = "UPDATE_SPECIFIC_CUSTOMER_STATUS";
export const CREATE_NEW_CUSTOMER_STATUS = "CREATE_NEW_CUSTOMER_STATUS";
export const REMOVE_CUSTOMER_STATUS = "REMOVE_CUSTOMER_STATUS";
export const GET_CUSTOMER_STATUS_ACTIVE = "GET_CUSTOMER_STATUS_ACTIVE";

// Trạng thái tương tác khách hàng
export const GET_LIST_INTERACTION_STATUS = "GET_LIST_INTERACTION_STATUS";
export const GET_SPECIFIC_INTERACTION_STATUS = "GET_SPECIFIC_INTERACTION_STATUS";
export const UPDATE_SPECIFIC_INTERACTION_STATUS = "UPDATE_SPECIFIC_INTERACTION_STATUS";
export const CREATE_NEW_INTERACTION_STATUS = "CREATE_NEW_INTERACTION_STATUS";
export const REMOVE_INTERACTION_STATUS = "REMOVE_INTERACTION_STATUS";
export const GET_INTERACTION_STATUS_ACTIVE = "GET_INTERACTION_STATUS_ACTIVE";

// Loại tương tác
export const GET_LIST_INTERACTION_TYPE = "GET_LIST_INTERACTION_TYPE";
export const GET_SPECIFIC_INTERACTION_TYPE = "GET_SPECIFIC_INTERACTION_TYPE";
export const UPDATE_SPECIFIC_INTERACTION_TYPE = "UPDATE_SPECIFIC_INTERACTION_TYPE";
export const CREATE_NEW_INTERACTION_TYPE = "CREATE_NEW_INTERACTION_TYPE";
export const REMOVE_INTERACTION_TYPE = "REMOVE_INTERACTION_TYPE";
export const GET_INTERACTION_TYPE_ACTIVE = "GET_INTERACTION_TYPE_ACTIVE";

// Nguồn khách hàng
export const GET_LIST_CUSTOMER_SOURCE = "GET_LIST_CUSTOMER_SOURCE";
export const GET_SPECIFIC_CUSTOMER_SOURCE = "GET_SPECIFIC_CUSTOMER_SOURCE";
export const UPDATE_SPECIFIC_CUSTOMER_SOURCE = "UPDATE_SPECIFIC_CUSTOMER_SOURCE";
export const CREATE_NEW_CUSTOMER_SOURCE = "CREATE_NEW_CUSTOMER_SOURCE";
export const REMOVE_CUSTOMER_SOURCE = "REMOVE_CUSTOMER_SOURCE";
export const GET_CUSTOMER_SOURCE_ACTIVE = "GET_CUSTOMER_SOURCE_ACTIVE";

// Page manager
export const GET_LIST_PAGE = "GET_LIST_PAGE";
export const GET_SPECIFIC_PAGE = "GET_SPECIFIC_PAGE";
export const CONNECT_PAGE = "CONNECT_PAGE";
export const INSERT_INFO_PAGE = "INSERT_INFO_PAGE";
export const GET_PAGE_BY_PAGEID = "GET_PAGE_BY_PAGEID";
export const UPDATE_STATTUS_PAGE = "UPDATE_STATTUS_PAGE";
export const GET_LIST_PAGE_ACTIVE = "GET_LIST_PAGE_ACTIVE";
export const UPDATE_SPECIFIC_PAGE = "UPDATE_SPECIFIC_PAGE";

// Regions
export const GET_LIST_PROVINCES = "GET_LIST_PROVINCES";
export const GET_LIST_WARDS = "GET_LIST_WARDS";

// Stringee
export const STRINGEE_GET_TOKEN = "STRINGEE_GET_TOKEN";

//  Quản lý cơ sở
export const GET_LIST_BRANCH = "GET_LIST_BRANCH";
export const GET_SPECIFIC_BRANCH = "GET_SPECIFIC_BRANCH";
export const UPDATE_SPECIFIC_BRANCH = "UPDATE_SPECIFIC_BRANCH";
export const CREATE_NEW_BRANCH = "CREATE_NEW_BRANCH";
export const REMOVE_BRANCH = "REMOVE_BRANCH";
export const GET_BRANCH_ACTIVE = "GET_BRANCH_ACTIVE";

// Role group
export const GET_LIST_ROLE_GROUP = "GET_LIST_ROLE_GROUP";
export const GET_SPECIFIC_ROLE_GROUP = "GET_SPECIFIC_ROLE_GROUP";
export const UPDATE_SPECIFIC_ROLE_GROUP = "UPDATE_SPECIFIC_ROLE_GROUP";
export const CREATE_NEW_ROLE_GROUP = "CREATE_NEW_ROLE_GROUP";
export const REMOVE_ROLE_GROUP = "REMOVE_ROLE_GROUP";
export const GET_ROLE_GROUP_ACTIVE = "GET_ROLE_GROUP_ACTIVE";

// Danh sách bệnh
export const GET_LIST_DISEASES = "GET_LIST_DISEASES";
export const GET_SPECIFIC_DISEASES = "GET_SPECIFIC_DISEASES";
export const UPDATE_SPECIFIC_DISEASES = "UPDATE_SPECIFIC_DISEASES";
export const CREATE_NEW_DISEASES = "CREATE_NEW_DISEASES";
export const REMOVE_DISEASES = "REMOVE_DISEASES";
export const GET_DISEASES_ACTIVE = "GET_DISEASES_ACTIVE";

// Nhóm máu
export const GET_LIST_BLOOD_GROUP = "GET_LIST_BLOOD_GROUP";
export const GET_SPECIFIC_BLOOD_GROUP = "GET_SPECIFIC_BLOOD_GROUP";
export const UPDATE_SPECIFIC_BLOOD_GROUP = "UPDATE_SPECIFIC_BLOOD_GROUP";
export const CREATE_NEW_BLOOD_GROUP = "CREATE_NEW_BLOOD_GROUP";
export const REMOVE_BLOOD_GROUP = "REMOVE_BLOOD_GROUP";
export const GET_BLOOD_GROUP_ACTIVE = "GET_BLOOD_GROUP_ACTIVE";

// Dịch vụ của khách hàng
export const CUSTOMER_SERVICES_GET_LIST = "CUSTOMER_SERVICES_GET_LIST";
export const CUSTOMER_SERVICES_GET_SPECIFIC = "CUSTOMER_SERVICES_GET_SPECIFIC";
export const CUSTOMER_SERVICES_UPDATE_SPECIFIC = "CUSTOMER_SERVICES_UPDATE_SPECIFIC";
export const CUSTOMER_SERVICES_CREATE_NEW = "CUSTOMER_SERVICES_CREATE_NEW";
export const CUSTOMER_SERVICES_CONVERT_TO_SERVICE = "CUSTOMER_SERVICES_CONVERT_TO_SERVICE";
export const CUSTOMER_SERVICES_REMOVE = "CUSTOMER_SERVICES_REMOVE";
export const CUSTOMER_SERVICES_GET_STATISTICAL = "CUSTOMER_SERVICES_GET_STATISTICAL";
export const CUSTOMER_SERVICES = "CUSTOMER_SERVICES";
export const CUSTOMER_SERVICES_EXPORT_EXCEL = "CUSTOMER_SERVICES_EXPORT_EXCEL";

// Phiếu thu
export const GET_LIST_RECEIPTS = 'GET_LIST_RECEIPTS';
export const GET_ACTIVE_RECEIPTS = 'GET_ACTIVE_RECEIPTS';
export const GET_SPECIFIC_RECEIPT = 'GET_SPECIFIC_RECEIPT';
export const CREATE_NEW_RECEIPT = 'CREATE_NEW_RECEIPT';
export const UPDATE_SPECIFIC_RECEIPT = 'UPDATE_SPECIFIC_RECEIPT';
export const REMOVE_RECEIPTS = 'REMOVE_RECEIPTS';
export const GET_RECEIPTS_BY_CUSTOMER = 'GET_RECEIPTS_BY_CUSTOMER';
export const EXPORT_RECEIPTS_EXCEL = 'EXPORT_RECEIPTS_EXCEL';

// Phiếu chi
export const GET_LIST_PAYMENT_VOUCHER = "GET_LIST_PAYMENT_VOUCHER";
export const GET_SPECIFIC_PAYMENT_VOUCHER = "GET_SPECIFIC_PAYMENT_VOUCHER";
export const UPDATE_SPECIFIC_PAYMENT_VOUCHER = "UPDATE_SPECIFIC_PAYMENT_VOUCHER";
export const CREATE_NEW_PAYMENT_VOUCHER = "CREATE_NEW_PAYMENT_VOUCHER";
export const REMOVE_PAYMENT_VOUCHER = "REMOVE_PAYMENT_VOUCHER";
export const GET_LIST_PAYMENT_VOUCHER_WITH_CONCATENATE = "GET_LIST_PAYMENT_VOUCHER_WITH_CONCATENATE";

// Voucher khách hàng
export const GET_ALL_VOUCHER = 'GET_ALL_VOUCHER';
export const CREATE_NEW_VOUCHER = 'CREATE_NEW_VOUCHER';
export const UPDATE_SPECIFIC_VOUCHER = 'UPDATE_SPECIFIC_VOUCHER';
export const GET_SPECIFIC_VOUCHER = 'GET_SPECIFIC_VOUCHER';
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export const GET_ALL_VOUCHER_WITH_CONCATENATE = 'GET_ALL_VOUCHER_WITH_CONCATENATE';
export const GET_ALL_VOUCHER_BY_ACTIVE = 'GET_ALL_VOUCHER_BY_ACTIVE';
export const VOUCHER_APPLY_CUSTOMER = 'VOUCHER_APPLY_CUSTOMER';
export const VOUCHER_CUSTOMER_REMOVE = 'VOUCHER_CUSTOMER_REMOVE';
export const VOUCHER_CUSTOMER_UPDATE = 'VOUCHER_CUSTOMER_UPDATE';
export const VOUCHER_CUSTOMER_GET_USED = 'VOUCHER_CUSTOMER_GET_USED';
export const VOUCHER_CUSTOMER_GET_USED_BY_CUSTOMER = 'VOUCHER_CUSTOMER_GET_USED_BY_CUSTOMER';

// So quy
export const GET_LIST_CASH_BOOK = "GET_LIST_CASH_BOOK";
export const GET_SPECIFIC_CASH_BOOK = "GET_SPECIFIC_CASH_BOOK";
export const UPDATE_SPECIFIC_CASH_BOOK = "UPDATE_SPECIFIC_CASH_BOOK";
export const CREATE_NEW_CASH_BOOK = "CREATE_NEW_CASH_BOOK";
export const REMOVE_CASH_BOOK = "REMOVE_CASH_BOOK";
export const GET_STATISTICAL_CASH_BOOK = "GET_STATISTICAL_CASH_BOOK";

// Nhóm sản phẩm
export const GET_LIST_PRODUCT_GROUP = "GET_LIST_PRODUCT_GROUP";
export const GET_SPECIFIC_PRODUCT_GROUP = "GET_SPECIFIC_PRODUCT_GROUP";
export const UPDATE_SPECIFIC_PRODUCT_GROUP = "UPDATE_SPECIFIC_PRODUCT_GROUP";
export const CREATE_NEW_PRODUCT_GROUP = "CREATE_NEW_PRODUCT_GROUP";
export const REMOVE_PRODUCT_GROUP = "REMOVE_PRODUCT_GROUP";
export const GET_PRODUCT_GROUP_ACTIVE = "GET_PRODUCT_GROUP_ACTIVE";

// Nhà cung cấp
export const GET_ALL_PRODUCT_SUPPLIER = "GET_ALL_PRODUCT_SUPPLIER";
export const GET_PRODUCT_SUPPLIER = "GET_PRODUCT_SUPPLIER";
export const CREATE_PRODUCT_SUPPLIER = "CREATE_PRODUCT_SUPPLIER";
export const UPDATE_PRODUCT_SUPPLIER = "UPDATE_PRODUCT_SUPPLIER";
export const REMOVE_PRODUCT_SUPPLIER = "REMOVE_PRODUCT_SUPPLIER";
export const GET_PRODUCT_SUPPLIER_ACTIVE = "GET_PRODUCT_SUPPLIER_ACTIVE";

// Quản lý kho
export const GET_ALL_PRODUCT_WAREHOUSE = "GET_ALL_PRODUCT_WAREHOUSE";
export const GET_PRODUCT_WAREHOUSE = "GET_PRODUCT_WAREHOUSE";
export const CREATE_PRODUCT_WAREHOUSE = "CREATE_PRODUCT_WAREHOUSE";
export const UPDATE_PRODUCT_WAREHOUSE = "UPDATE_PRODUCT_WAREHOUSE";
export const REMOVE_PRODUCT_WAREHOUSE = "REMOVE_PRODUCT_WAREHOUSE";
export const GET_PRODUCT_WAREHOUSE_ACTIVE = "GET_PRODUCT_WAREHOUSE_ACTIVE";

// Sản phẩm
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_ACTIVE_PRODUCTS = 'FETCH_ACTIVE_PRODUCTS';
export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const REMOVE_PRODUCTS = 'REMOVE_PRODUCTS';
export const FETCH_PRODUCT_STATS = 'FETCH_PRODUCT_STATS';
export const FETCH_INVENTORY_STATS = 'FETCH_INVENTORY_STATS';
export const EXPORT_INVENTORY_STATS = 'EXPORT_INVENTORY_STATS';

// Phiếu nhập kho
export const GET_ALL_PRODUCT_RECEIPT_IMPORT = "GET_ALL_PRODUCT_RECEIPT_IMPORT";
export const CREATE_NEW_PRODUCT_RECEIPT_IMPORT = "CREATE_NEW_PRODUCT_RECEIPT_IMPORT";
export const UPDATE_SPECIFIC_PRODUCT_RECEIPT_IMPORT = "UPDATE_SPECIFIC_PRODUCT_RECEIPT_IMPORT";
export const REMOVE_PRODUCT_RECEIPT_IMPORT = "REMOVE_PRODUCT_RECEIPT_IMPORT";
export const GET_SPECIFIC_PRODUCT_RECEIPT_IMPORT = "GET_SPECIFIC_PRODUCT_RECEIPT_IMPORT";
export const PRODUCT_RECEIPT_IMPORT_EXPORT_EXCEL = "PRODUCT_RECEIPT_IMPORT_EXPORT_EXCEL";

//Phiếu xuất kho
export const GET_ALL_PRODUCT_RECEIPT_EXPORT = "GET_ALL_PRODUCT_RECEIPT_EXPORT";
export const CREATE_NEW_PRODUCT_RECEIPT_EXPORT = "CREATE_NEW_PRODUCT_RECEIPT_EXPORT";
export const UPDATE_SPECIFIC_PRODUCT_RECEIPT_EXPORT = "UPDATE_SPECIFIC_PRODUCT_RECEIPT_EXPORT";
export const REMOVE_PRODUCT_RECEIPT_EXPORT = "REMOVE_PRODUCT_RECEIPT_EXPORT";
export const GET_SPECIFIC_PRODUCT_RECEIPT_EXPORT = "GET_SPECIFIC_PRODUCT_RECEIPT_EXPORT";
export const PRODUCT_RECEIPT_EXPORT_EXPORT_EXCEL = "PRODUCT_RECEIPT_EXPORT_EXPORT_EXCEL";

// UNIT
export const GET_LIST_UNIT = "GET_LIST_UNIT";
export const GET_SPECIFIC_UNIT = "GET_SPECIFIC_UNIT";
export const UPDATE_SPECIFIC_UNIT = "UPDATE_SPECIFIC_UNIT";
export const CREATE_NEW_UNIT = "CREATE_NEW_UNIT";
export const REMOVE_UNIT = "REMOVE_UNIT";
export const GET_UNIT_ACTIVE = "GET_UNIT_ACTIVE";

// Tinh trang san pham
export const GET_LIST_PRODUCT_STATUS = "GET_LIST_PRODUCT_STATUS";
export const GET_SPECIFIC_PRODUCT_STATUS = "GET_SPECIFIC_PRODUCT_STATUS";
export const UPDATE_SPECIFIC_PRODUCT_STATUS = "UPDATE_SPECIFIC_PRODUCT_STATUS";
export const CREATE_NEW_PRODUCT_STATUS = "CREATE_NEW_PRODUCT_STATUS";
export const REMOVE_PRODUCT_STATUS = "REMOVE_PRODUCT_STATUS";
export const GET_PRODUCT_STATUS_ACTIVE = "GET_PRODUCT_STATUS_ACTIVE";

// Guide
export const GET_ALL_GUIDE = "GET_ALL_GUIDE";
export const GET_SPECIFIC_GUIDE = "GET_SPECIFIC_GUIDE";
export const UPDATE_SPECIFIC_GUIDE = "UPDATE_SPECIFIC_GUIDE";
export const CREATE_NEW_GUIDE = "CREATE_NEW_GUIDE";
export const REMOVE_GUIDE = "REMOVE_GUIDE";

// Bài viết
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POST = 'FETCH_POST';
export const CREATE_POST = 'CREATE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const REMOVE_POSTS = 'REMOVE_POSTS';

// Báo cáo công việc
export const GET_ALL_WORK_REPORT = "GET_ALL_WORK_REPORT";
export const GET_SPECIFIC_WORK_REPORT = "GET_SPECIFIC_WORK_REPORT";
export const UPDATE_SPECIFIC_WORK_REPORT = "UPDATE_SPECIFIC_WORK_REPORT";
export const CREATE_NEW_WORK_REPORT = "CREATE_NEW_WORK_REPORT";
export const REMOVE_WORK_REPORT = "REMOVE_WORK_REPORT";
export const COMMENT_WORK_REPORT = "COMMENT_WORK_REPORT";
export const WORK_REPORT_EXPORT_EXCEL = "WORK_REPORT_EXPORT_EXCEL";

// Comment
export const CREATE_COMMENT = "CREATE_COMMENT";
export const REMOVE_COMMENT = "REMOVE_COMMENT";

// Khách hàng tiềm năng
export const CUSTOMER_PROSPECT_LIST = "CUSTOMER_PROSPECT_LIST";
export const CUSTOMER_PROSPECT_GET = "CUSTOMER_PROSPECT_GET";
export const CUSTOMER_PROSPECT_UPDATE = "CUSTOMER_PROSPECT_UPDATE";
export const CUSTOMER_PROSPECT_CREATE = "CUSTOMER_PROSPECT_CREATE";
export const CUSTOMER_PROSPECT_DELETE = "CUSTOMER_PROSPECT_DELETE";
export const CUSTOMER_PROSPECT_LIST_ACTIVE = "CUSTOMER_PROSPECT_LIST_ACTIVE";
export const CUSTOMER_PROSPECT_LIST_NAME = "CUSTOMER_PROSPECT_LIST_NAME";
export const CUSTOMER_PROSPECT_IMPORT = "CUSTOMER_PROSPECT_IMPORT";

// Lịch sử xem số điện thoại khách hàng
export const GET_LIST_VIEW_PHONENUMBER = 'GET_LIST_VIEW_PHONENUMBER';
export const CREATE_NEW_VIEW_PHONENUMBER = 'CREATE_NEW_VIEW_PHONENUMBER';
export const REMOVE_VIEW_PHONENUMBER = 'REMOVE_VIEW_PHONENUMBER';

// Firebase
export const ADD_DEVICE_TOKEN = "ADD_DEVICE_TOKEN";
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_SUMMARY = "FETCH_NOTIFICATIONS_SUMMARY";
export const SET_UNREAD_COUNT_NOTIFICATIONS = 'SET_UNREAD_COUNT_NOTIFICATIONS';
export const MARK_READ_NOTIFICATIONS = 'MARK_READ_NOTIFICATIONS';
export const MARK_ALL_READ_NOTIFICATIONS = 'MARK_ALL_READ_NOTIFICATIONS';
export const MARK_NOTIFICATION_UNREAD = 'MARK_NOTIFICATION_UNREAD';

// Lịch sử thay đổi
export const GET_LIST_HISTORY = "GET_LIST_HISTORY";
export const GET_SPECIFIC_HISTORY = "GET_SPECIFIC_HISTORY";
export const REMOVE_HISTORY = "REMOVE_HISTORY";

// Tùy chọn cột hiển thị
export const GET_LIST_USER_COLUMN_PREFERENCES = "GET_LIST_USER_COLUMN_PREFERENCES";
export const CREATE_NEW_USER_COLUMN_PREFERENCES = "CREATE_NEW_USER_COLUMN_PREFERENCES";

// Thống kê tổng hợp
export const SUMMARY_STATISTICS = "SUMMARY_STATISTICS";
export const REVENUE_STATISTICS = "REVENUE_STATISTICS";
export const STAFF_REVENUE_YEARLY = "STAFF_REVENUE_YEARLY";
export const STAFF_REVENUE_DETAIL = "STAFF_REVENUE_DETAIL";
export const STAFF_REVENUE_YEARLY_EXPORT_EXCEL = "STAFF_REVENUE_YEARLY_EXPORT_EXCEL";
export const STAFF_REVENUE_DETAIL_EXPORT_EXCEL = "STAFF_REVENUE_DETAIL_EXPORT_EXCEL";
export const STAFF_INCOME_DETAIL = "STAFF_INCOME_DETAIL";
export const GET_ASSISTANTS_SUPPORT_CASES = "GET_ASSISTANTS_SUPPORT_CASES";
export const ASSISTANTS_SUPPORT_CASE_EXPORT_EXCEL = "ASSISTANTS_SUPPORT_CASE_EXPORT_EXCEL";
export const ASSISTANTS_SUPPORT_CASE_EXPORT_ALL_EXCEL = 'ASSISTANTS_SUPPORT_CASE_EXPORT_ALL_EXCEL';
export const CUSTOMER_VISIT_STATISTICS = "CUSTOMER_VISIT_STATISTICS";

export const GET_LIST_COMMISSION = 'GET_LIST_COMMISSION';
export const COMMISSION_STATISTICAL = 'COMMISSION_STATISTICAL';

export const GET_COMMISSION_SNAPSHOTS = 'GET_COMMISSION_SNAPSHOTS';
export const GET_SPECIFIC_COMMISSION_SNAPSHOT = 'GET_SPECIFIC_COMMISSION_SNAPSHOT';
export const GET_COMMISSION_LOGS = 'GET_COMMISSION_LOGS';
export const GET_COMMISSION_AUDIT = 'GET_COMMISSION_AUDIT';
export const GET_COMMISSION_LEDGER_SUMMARY = 'GET_COMMISSION_LEDGER_SUMMARY';
export const REBUILD_COMMISSION = 'REBUILD_COMMISSION';
export const APPROVE_COMMISSION = 'APPROVE_COMMISSION';
export const UNAPPROVE_COMMISSION = 'UNAPPROVE_COMMISSION';
export const MARK_PAID_COMMISSION = 'MARK_PAID_COMMISSION';
export const INVALIDATE_UNPAID_COMMISSION = 'INVALIDATE_UNPAID_COMMISSION';
export const GET_COMMISSION_PERIODS = 'GET_COMMISSION_PERIODS';

export const FETCH_COMMISSION_POLICIES = 'FETCH_COMMISSION_POLICIES';
export const FETCH_COMMISSION_RULE_DETAIL = 'FETCH_COMMISSION_RULE_DETAIL';
export const CREATE_COMMISSION_RULE = 'CREATE_COMMISSION_RULE';
export const UPDATE_COMMISSION_RULE = 'UPDATE_COMMISSION_RULE';
export const DELETE_COMMISSION_RULES = 'DELETE_COMMISSION_RULES';

export const GET_ADDITINOAL_COST_CUSTOMER = "GET_ADDITINOAL_COST_CUSTOMER";
export const REMOVE_ADDITINOAL_COST = "REMOVE_ADDITINOAL_COST";
export const CREATE_ADDITINOAL_COST = "CREATE_ADDITINOAL_COST";
export const UPDATE_SPECIFIC_ADDITINOAL_COST = "UPDATE_SPECIFIC_ADDITINOAL_COST";
export const GET_SPECIFIC_ADDITINOAL_COST = "GET_SPECIFIC_ADDITINOAL_COST";

export const ZALO_OA_GRANT_PERMISSION = "ZALO_OA_GRANT_PERMISSION";
export const GET_LIST_OA = "GET_LIST_OA";

export const SEARCH_AUDIT_LOGS = 'SEARCH_AUDIT_LOGS';
export const GET_AUDIT_LOG_DETAIL = 'GET_AUDIT_LOG_DETAIL';
export const ROLLBACK_AUDIT_LOG = 'ROLLBACK_AUDIT_LOG';
export const GET_AUDIT_LOG_MODELS = 'GET_AUDIT_LOG_MODELS';

export const FETCH_LABOS = "FETCH_LABOS";
export const CREATE_LABO = "CREATE_LABO";
export const UPDATE_LABO = "UPDATE_LABO";
export const DELETE_LABOS = "DELETE_LABOS";
export const FETCH_LABO_DETAIL = "FETCH_LABO_DETAIL";
export const FETCH_ACTIVE_LABOS = "FETCH_ACTIVE_LABOS ";

export const FETCH_LABO_CASES = "FETCH_LABO_CASES";
export const CREATE_LABO_CASE = "CREATE_LABO_CASE";
export const UPDATE_LABO_CASE = "UPDATE_LABO_CASE";
export const DELETE_LABO_CASES = "DELETE_LABO_CASES";
export const FETCH_LABO_CASE_DETAIL = "FETCH_LABO_CASE_DETAIL";
export const FETCH_LABO_CASE_STATUS_STATISTICS = 'FETCH_LABO_CASE_STATUS_STATISTICS';
export const FETCH_LABO_CASE_CUSTOMER_STATISTICS = 'FETCH_LABO_CASE_CUSTOMER_STATISTICS';

export const GET_ALL_FEEDBACK_REQUEST = 'GET_ALL_FEEDBACK_REQUEST';
export const GET_SPECIFIC_FEEDBACK_REQUEST = 'GET_SPECIFIC_FEEDBACK_REQUEST';
export const CREATE_NEW_FEEDBACK_REQUEST = 'CREATE_NEW_FEEDBACK_REQUEST';
export const UPDATE_SPECIFIC_FEEDBACK_REQUEST = 'UPDATE_SPECIFIC_FEEDBACK_REQUEST';
export const REMOVE_FEEDBACK_REQUEST = 'REMOVE_FEEDBACK_REQUEST';


// Quản lý treatment note
export const GET_TREATMENT_NOTES = 'GET_TREATMENT_NOTES';
export const GET_PENDING_TREATMENT_NOTES = 'GET_PENDING_TREATMENT_NOTES';
export const GET_TREATMENT_NOTE_DETAIL = 'GET_TREATMENT_NOTE_DETAIL';
export const CREATE_TREATMENT_NOTE = 'CREATE_TREATMENT_NOTE';
export const UPDATE_TREATMENT_NOTE = 'UPDATE_TREATMENT_NOTE';
export const CONFIRM_TREATMENT_NOTE = 'CONFIRM_TREATMENT_NOTE';
export const UNCONFIRM_TREATMENT_NOTE = 'UNCONFIRM_TREATMENT_NOTE';
export const CONFIRM_EDIT_TREATMENT_NOTE = 'CONFIRM_EDIT_TREATMENT_NOTE';
export const REMOVE_TREATMENT_NOTES = 'REMOVE_TREATMENT_NOTES';
export const GET_TREATMENT_NOTES_STATISTIC_BY_DOCTOR = 'GET_TREATMENT_NOTES_STATISTIC_BY_DOCTOR';

// Quỹ cơ sở 
export const GET_LIST_BRANCH_FUNDS = 'GET_LIST_BRANCH_FUNDS';
export const GET_SPECIFIC_BRANCH_FUNDS = 'GET_SPECIFIC_BRANCH_FUNDS';
export const UPDATE_SPECIFIC_BRANCH_FUNDS = 'UPDATE_SPECIFIC_BRANCH_FUNDS';
export const CREATE_NEW_BRANCH_FUNDS = 'CREATE_NEW_BRANCH_FUNDS';
export const REMOVE_BRANCH_FUNDS = 'REMOVE_BRANCH_FUNDS';

// Quản lý procedure (Thủ thuật)
export const GET_LIST_PROCEDURE = 'GET_LIST_PROCEDURE';
export const GET_SPECIFIC_PROCEDURE = 'GET_SPECIFIC_PROCEDURE';
export const CREATE_NEW_PROCEDURE = 'CREATE_NEW_PROCEDURE';
export const UPDATE_SPECIFIC_PROCEDURE = 'UPDATE_SPECIFIC_PROCEDURE';
export const REMOVE_PROCEDURE = 'REMOVE_PROCEDURE';
export const GET_PROCEDURE_ACTIVE = 'GET_PROCEDURE_ACTIVE';

//  FETCH_FILTERS
export const FETCH_FILTERS = 'FETCH_FILTERS';


export const GET_BY_CUSTOMER = 'GET_BY_CUSTOMER';
export const UPDATE_SPECIFIC_ORTHODONTIC_PLAN = 'UPDATE_SPECIFIC_ORTHODONTIC_PLAN';


export const CREATE_ORTHODONTIC_COMMENT = 'CREATE_ORTHODONTIC_COMMENT';
export const UPDATE_ORTHODONTIC_COMMENT = 'UPDATE_ORTHODONTIC_COMMENT';
export const DELETE_ORTHODONTIC_COMMENT = 'DELETE_ORTHODONTIC_COMMENT';
export const GET_ORTHODONTIC_COMMENTS = 'GET_ORTHODONTIC_COMMENTS';


export const GET_IMAGE_FOLDERS = "GET_IMAGE_FOLDERS";
export const CREATE_IMAGE_FOLDER = "CREATE_IMAGE_FOLDER";
export const UPDATE_IMAGE_FOLDER = "UPDATE_IMAGE_FOLDER";
export const DELETE_IMAGE_FOLDER = "DELETE_IMAGE_FOLDER";

export const UPLOAD_IMAGES = "UPLOAD_IMAGES";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
export const DELETE_IMAGE = "DELETE_IMAGE";

export const FETCH_CUS_SERVICE_MILESTONES = "FETCH_CUS_SERVICE_MILESTONES";
export const CREATE_CUS_SERVICE_MILESTONE = "CREATE_CUS_SERVICE_MILESTONE";
export const UPDATE_CUS_SERVICE_MILESTONE = "UPDATE_CUS_SERVICE_MILESTONE";
export const DELETE_CUS_SERVICE_MILESTONES = "DELETE_CUS_SERVICE_MILESTONE";
export const FETCH_CUS_SERVICE_MILESTONE_DETAIL = "FETCH_CUS_SERVICE_MILESTONE_DETAIL";
export const UPDATE_CUS_SERVICE_MILESTONE_FIELD = "UPDATE_CUS_SERVICE_MILESTONE_FIELD";
export const NOTIFICATION_CUS_SERVICE_MILESTONES = "NOTIFICATION_CUS_SERVICE_MILESTONES";


export const GET_LIST_INSTRUCTION_TEMPLATE = "GET_LIST_INSTRUCTION_TEMPLATE";
export const GET_SPECIFIC_INSTRUCTION_TEMPLATE = "GET_SPECIFIC_INSTRUCTION_TEMPLATE";
export const UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE = "UPDATE_SPECIFIC_INSTRUCTION_TEMPLATE";
export const CREATE_NEW_INSTRUCTION_TEMPLATE = "CREATE_NEW_INSTRUCTION_TEMPLATE";
export const REMOVE_INSTRUCTION_TEMPLATE = "REMOVE_INSTRUCTION_TEMPLATE";
export const GET_INSTRUCTION_TEMPLATE_ACTIVE = "GET_INSTRUCTION_TEMPLATE_ACTIVE";


export const GET_LIST_PRESCRIPTION_TEMPLATE = "admin.prescription_templates.list";
export const CREATE_NEW_PRESCRIPTION_TEMPLATE = "admin.prescription_templates.create";
export const GET_SPECIFIC_PRESCRIPTION_TEMPLATE = "admin.prescription_templates.detail";
export const UPDATE_SPECIFIC_PRESCRIPTION_TEMPLATE = "admin.prescription_templates.update";
export const REMOVE_PRESCRIPTION_TEMPLATE = "admin.prescription_templates.remove";
export const GET_PRESCRIPTION_TEMPLATE_ACTIVE = "admin.prescription_templates.active";


export const GET_LIST_TREATMENT_SESSION = 'GET_LIST_TREATMENT_SESSION';
export const GET_TREATMENT_SESSION_BY_CUSTOMER = 'GET_TREATMENT_SESSION_BY_CUSTOMER';
export const GET_SPECIFIC_TREATMENT_SESSION = 'GET_SPECIFIC_TREATMENT_SESSION';
export const UPDATE_SPECIFIC_TREATMENT_SESSION = 'UPDATE_SPECIFIC_TREATMENT_SESSION';
export const CREATE_NEW_TREATMENT_SESSION = 'CREATE_NEW_TREATMENT_SESSION';
export const REMOVE_TREATMENT_SESSION = 'REMOVE_TREATMENT_SESSION';

export const GET_GENERAL_EXAM_BY_CUSTOMER = 'GET_GENERAL_EXAM_BY_CUSTOMER';
export const UPDATE_SPECIFIC_GENERAL_EXAM = 'UPDATE_SPECIFIC_GENERAL_EXAM';
export const CREATE_SPECIFIC_GENERAL_EXAM = 'CREATE_SPECIFIC_GENERAL_EXAM';
export const REMOVE_GENERAL_EXAM = 'REMOVE_GENERAL_EXAM';
export const GET_SPECIFIC_GENERAL_EXAM = 'GET_SPECIFIC_GENERAL_EXAM';


export const GET_ORTHODONTIC_EXAM_BY_CUSTOMER = 'GET_ORTHODONTIC_EXAM_BY_CUSTOMER';
export const UPDATE_SPECIFIC_ORTHODONTIC_EXAM = 'UPDATE_SPECIFIC_ORTHODONTIC_EXAM';
export const CREATE_SPECIFIC_ORTHODONTIC_EXAM = 'CREATE_SPECIFIC_ORTHODONTIC_EXAM';
export const REMOVE_ORTHODONTIC_EXAM = 'REMOVE_ORTHODONTIC_EXAM';
export const GET_SPECIFIC_ORTHODONTIC_EXAM = 'GET_SPECIFIC_ORTHODONTIC_EXAM';

export const GET_MEDICAL_RECORD_BY_CUSTOMER = 'GET_MEDICAL_RECORD_BY_CUSTOMER';
export const UPDATE_SPECIFIC_MEDICAL_RECORD = 'UPDATE_SPECIFIC_MEDICAL_RECORD';

export const GET_LIST_CUSTOMER_CARE_CATEGORY = "GET_LIST_CUSTOMER_CARE_CATEGORY";
export const GET_SPECIFIC_CUSTOMER_CARE_CATEGORY = "GET_SPECIFIC_CUSTOMER_CARE_CATEGORY";
export const UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY = "UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY";
export const CREATE_NEW_CUSTOMER_CARE_CATEGORY = "CREATE_NEW_CUSTOMER_CARE_CATEGORY";
export const REMOVE_CUSTOMER_CARE_CATEGORY = "REMOVE_CUSTOMER_CARE_CATEGORY";
export const GET_CUSTOMER_CARE_CATEGORY_ACTIVE = "GET_CUSTOMER_CARE_CATEGORY_ACTIVE";

export const GET_LIST_CUSTOMER_CARE_LOG = "GET_LIST_CUSTOMER_CARE_LOG";
export const GET_SPECIFIC_CUSTOMER_CARE_LOG = "GET_SPECIFIC_CUSTOMER_CARE_LOG";
export const UPDATE_SPECIFIC_CUSTOMER_CARE_LOG = "UPDATE_SPECIFIC_CUSTOMER_CARE_LOG";
export const CREATE_NEW_CUSTOMER_CARE_LOG = "CREATE_NEW_CUSTOMER_CARE_LOG";
export const REMOVE_CUSTOMER_CARE_LOG = "REMOVE_CUSTOMER_CARE_LOG";
export const GET_CUSTOMER_CARE_LOG_ACTIVE = "GET_CUSTOMER_CARE_LOG_ACTIVE";

export const GET_LIST_CUSTOMER_COMPLAINT = "GET_LIST_CUSTOMER_COMPLAINT";
export const GET_SPECIFIC_CUSTOMER_COMPLAINT = "GET_SPECIFIC_CUSTOMER_COMPLAINT";
export const CREATE_CUSTOMER_COMPLAINT = "CREATE_CUSTOMER_COMPLAINT";
export const UPDATE_CUSTOMER_COMPLAINT = "UPDATE_CUSTOMER_COMPLAINT";
export const REMOVE_CUSTOMER_COMPLAINT = "REMOVE_CUSTOMER_COMPLAINT";

// Monitoring
export const GET_MONITORING_MISSING_TREATMENT_SESSIONS = 'GET_MONITORING_MISSING_TREATMENT_SESSIONS';

// TELESALE FOLLOW UP
export const GET_TELESALE_FOLLOW_UPS = 'GET_TELESALE_FOLLOW_UPS';
export const GET_TELESALE_FOLLOW_UP = 'GET_TELESALE_FOLLOW_UP';
export const ASSIGN_TELESALE_FOLLOW_UP = 'ASSIGN_TELESALE_FOLLOW_UP';
export const UPDATE_TELESALE_FOLLOW_UP = 'UPDATE_TELESALE_FOLLOW_UP';
export const REMOVE_TELESALE_FOLLOW_UP = 'REMOVE_TELESALE_FOLLOW_UP';
export const GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER = 'GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER';
export const CREATE_TELESALE_FOLLOW_UP = 'CREATE_TELESALE_FOLLOW_UP';


export const FETCH_CUSTOMER_PARTNERS = 'FETCH_CUSTOMER_PARTNERS';

export const FETCH_DOCTOR_CUSTOMERS = 'FETCH_DOCTOR_CUSTOMERS';

export const GET_LIST_DOCTOR_APPOINTMENTS = 'GET_LIST_DOCTOR_APPOINTMENTS';
export const GET_DOCTOR_APPOINTMENTS_STATISTICS = 'GET_DOCTOR_APPOINTMENTS_STATISTICS';

// Tính hoa hồng
export const FETCH_COMMISSION_DASHBOARD = 'FETCH_COMMISSION_DASHBOARD';
export const FETCH_COMMISSION_DASHBOARD_ITEM = 'FETCH_COMMISSION_DASHBOARD_ITEM';
export const FETCH_COMMISSION_DASHBOARD_LEDGER = 'FETCH_COMMISSION_DASHBOARD_LEDGER';
export const FETCH_COMMISSION_DASHBOARD_ADJUSTMENTS = 'FETCH_COMMISSION_DASHBOARD_ADJUSTMENTS';
export const FETCH_COMMISSION_DASHBOARD_PAYMENTS = 'FETCH_COMMISSION_DASHBOARD_PAYMENTS';
export const FETCH_COMMISSION_DASHBOARD_UPCOMING = 'FETCH_COMMISSION_DASHBOARD_UPCOMING';
export const FETCH_COMMISSION_DASHBOARD_HOLDS = 'FETCH_COMMISSION_DASHBOARD_HOLDS';
export const FETCH_COMMISSION_PERIODS = 'FETCH_COMMISSION_PERIODS';
export const FETCH_COMMISSION_RECONCILIATION = 'FETCH_COMMISSION_RECONCILIATION';
export const FETCH_COMMISSION_APPROVALS = 'FETCH_COMMISSION_APPROVALS';
export const FETCH_COMMISSION_PAYOUTS = 'FETCH_COMMISSION_PAYOUTS';
export const FETCH_COMMISSION_PAYOUT_HISTORY = 'FETCH_COMMISSION_PAYOUT_HISTORY';

// Cấu hình điều kiện/vật tư theo nhóm dịch vụ
export const FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS = 'FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS';
export const FETCH_SERVICE_GROUP_CONFIGURATION = 'FETCH_SERVICE_GROUP_CONFIGURATION';

// Danh mục văn bản
export const GET_LIST_DOCUMENT_CATEGORIES = 'GET_LIST_DOCUMENT_CATEGORIES';
export const GET_SPECIFIC_DOCUMENT_CATEGORIES = 'GET_SPECIFIC_DOCUMENT_CATEGORIES';
export const UPDATE_SPECIFIC_DOCUMENT_CATEGORIES = 'UPDATE_SPECIFIC_DOCUMENT_CATEGORIES';
export const CREATE_NEW_DOCUMENT_CATEGORIES = 'CREATE_NEW_DOCUMENT_CATEGORIES';
export const REMOVE_DOCUMENT_CATEGORIES = 'REMOVE_DOCUMENT_CATEGORIES';
export const GET_DOCUMENT_CATEGORIES_ACTIVE = 'GET_DOCUMENT_CATEGORIES_ACTIVE';

// Văn bản
export const GET_LIST_DOCUMENTS = 'GET_LIST_DOCUMENTS';
export const GET_ONE_DOCUMENTS = 'GET_ONE_DOCUMENTS';
export const CREATE_DOCUMENTS = 'CREATE_DOCUMENTS';
export const UPDATE_DOCUMENTS = 'UPDATE_DOCUMENTS';
export const REMOVE_DOCUMENTS = 'REMOVE_DOCUMENTS';
export const GET_DOCUMENTS_BY_CATEGORY = 'GET_DOCUMENTS_BY_CATEGORY';

// Quay thưởng
export const GET_LIST_REWARD_HISTORIES = "GET_LIST_REWARD_HISTORIES";
export const GET_LIST_REWARD_CUSTOMER_HAS = "GET_LIST_REWARD_CUSTOMER_HAS";
export const REWARD_GET_CONFIG = "REWARD_GET_CONFIG";

// Quản lý dự án
export const GET_LIST_PROJECT = "GET_LIST_PROJECT";
export const GET_SPECIFIC_PROJECT = "GET_SPECIFIC_PROJECT";
export const UPDATE_SPECIFIC_PROJECT = "UPDATE_SPECIFIC_PROJECT";
export const CREATE_NEW_PROJECT = "CREATE_NEW_PROJECT";
export const REMOVE_PROJECT = "REMOVE_PROJECT";
export const GET_PROJECT_ACTIVE = "GET_PROJECT_ACTIVE";
export const CLONE_PROJECT = "CLONE_PROJECT";

// Công việc của dự án
export const GET_PROJECT_JOBS = "GET_PROJECT_JOBS";
export const GET_PROJECT_JOB = "GET_PROJECT_JOB";
export const UPDATE_PROJECT_JOB = "UPDATE_PROJECT_JOB";
export const CREATE_PROJECT_JOB = "CREATE_PROJECT_JOB";
export const REMOVE_PROJECT_JOBS = "REMOVE_PROJECT_JOBS";
export const UPDATE_PROJECT_JOB_RESULT = "UPDATE_PROJECT_JOB_RESULT";
export const UPDATE_PROJECT_JOB_STATUS = "UPDATE_PROJECT_JOB_STATUS";
export const ASSIGN_PROJECT_JOBS = "ASSIGN_PROJECT_JOBS";

// Quản lý thẻ khách hàng
export const FETCH_CARD_TYPES = 'FETCH_CARD_TYPES';
export const FETCH_ACTIVE_CARD_TYPES = 'FETCH_ACTIVE_CARD_TYPES';
export const FETCH_CARD_TYPE = 'FETCH_CARD_TYPE';
export const REMOVE_CARD_TYPES = 'REMOVE_CARD_TYPES';

export const FETCH_CARD_ISSUED_COUNTS = 'FETCH_CARD_ISSUED_COUNTS';
export const FETCH_CARD_ISSUED_COUNT = 'FETCH_CARD_ISSUED_COUNT';
export const REMOVE_CARD_ISSUED_COUNTS = 'REMOVE_CARD_ISSUED_COUNTS';

export const FETCH_CARD_RELEASE_TRACKINGS = 'FETCH_CARD_RELEASE_TRACKINGS';
export const FETCH_CARD_RELEASE_TRACKING = 'FETCH_CARD_RELEASE_TRACKING';
export const REMOVE_CARD_RELEASE_TRACKINGS = 'REMOVE_CARD_RELEASE_TRACKINGS';

export const FETCH_CARD_PENDING_CUSTOMERS = 'FETCH_CARD_PENDING_CUSTOMERS';

// Phân ca làm việc
export const FETCH_SCHEDULE_AREAS = 'FETCH_SCHEDULE_AREAS';
export const FETCH_ACTIVE_SCHEDULE_AREAS = 'FETCH_ACTIVE_SCHEDULE_AREAS';
export const FETCH_SCHEDULE_AREA = 'FETCH_SCHEDULE_AREA';
export const FETCH_SCHEDULE_AREA_FUNCTIONS = 'FETCH_SCHEDULE_AREA_FUNCTIONS';
export const FETCH_SCHEDULE_AREA_FUNCTION = 'FETCH_SCHEDULE_AREA_FUNCTION';
export const FETCH_SCHEDULE_JOBS = 'FETCH_SCHEDULE_JOBS';
export const FETCH_SCHEDULE_JOB = 'FETCH_SCHEDULE_JOB';
export const FETCH_SCHEDULE_SHIFTS = 'FETCH_SCHEDULE_SHIFTS';
export const FETCH_SCHEDULE_SHIFT = 'FETCH_SCHEDULE_SHIFT';

// Tư vấn trực tiếp
export const FETCH_DIRECT_CONSULTATIONS = 'FETCH_DIRECT_CONSULTATIONS';
export const FETCH_DIRECT_CONSULTATION = 'FETCH_DIRECT_CONSULTATION';
export const UPDATE_DIRECT_CONSULTATION = 'UPDATE_DIRECT_CONSULTATION';
export const UPDATE_DIRECT_CONSULTATION_RESULT = 'UPDATE_DIRECT_CONSULTATION_RESULT';
export const REMOVE_DIRECT_CONSULTATIONS = 'REMOVE_DIRECT_CONSULTATIONS';
